import { Component, inject, OnInit } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { GetRoleName } from "../../shared/enums/AppRoles";

@Component({
  selector: 'no-role-access',
  templateUrl: 'no-role-access.component.html',
  standalone: true
})
export class NoRoleAccessComponent implements OnInit {
  private route = inject(ActivatedRoute);

  protected missingRoleNames: string[] = [];

  ngOnInit() {
    this.route.queryParams
      .subscribe((params) => {
        const missingRoles = !Array.isArray(params.roles) ? [params.roles] : params.roles;

        this.missingRoleNames = missingRoles.map(Number).map(GetRoleName);
      });
  }
}
